<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="" >{{ 'global.menu.home'|translate }}</a></li>
      <li><a href="" >{{'global.menu.transaction' | translate}}</a></li>
      <li><a class="active">{{'transaction.fund' | translate}}</a></li>
    </ol>
  </div>
    <div class="col-md-12">
      <div class="col-md-4">
        &nbsp;
      </div>
      <div class="col-md-4 centertext">
        <h2 class="changePasswordHeading">{{'transaction.fund' | translate}}</h2>
      </div>
      <div class="col-md-4">
        &nbsp;
      </div>
    </div>
    <div class="col-md-12">

      <div class="col-md-12 noPaddingMd-12 borderButtnDiv">
          <p class="headerButnP" [ngClass]="[chose1month ? 'activeButnA' : '']"><a  class="customA" (click) ='loadChartData("1MONTH")'>{{'transaction.button.last1month' | translate}}</a></p>

          <p class="headerButnP" [ngClass]="[chose3month ? 'activeButnA' : '']"><a  class="customA" (click) ='loadChartData("3MONTH")'>{{'transaction.button.last3month' | translate}}</a></p>

          <p class="headerButnP" [ngClass]="[chose1year ? 'activeButnA' : '']"><a   class="customA" (click) ='loadChartData("1YEAR")'>{{'transaction.button.last1year' | translate}}</a></p>

           <p class="headerButnP" [ngClass]="[choseperiod ? 'activeButnA' : '']"><a  class="customA" (click) ='loadChartData("PERIOD")'>{{'transaction.button.customperiod' | translate}}</a></p>

      </div>

    </div>
  <form class="form-horizontal" [formGroup]="customFundForm" novalidate (submit)="requestPerformance()">
  <div class="col-md-12 customPadding" *ngIf="showCustomRange">
    <div class="col-md-2">
      &nbsp;
    </div>
    <div class="col-md-3 customCalendarDiv">
      <label class="dobLabel">{{'global.form.from' | translate}} &nbsp;*</label>
      <dp-date-picker mode="month"  #monthPicker formControlName="fundStartDate" [(ngModel)]="fromDate" [config]="datePickerConfig"></dp-date-picker>
      <span (click)="dateOpen()"><img  class="calendarIcon" src="assets/images/ppm/calendar.png"/></span>


    </div>
    <div class="col-md-2">
    </div>
    <div class="col-md-3 customCalendarDiv">
      <label class="dobLabel">{{'global.form.to' | translate}} &nbsp;*</label>
      <dp-date-picker mode="month" #monthPicker2 formControlName="fundEndDate" [(ngModel)]="toDate" [config]="datePickerConfig" ></dp-date-picker>
      <span (click)="dateOpen2()"><img  class="calendarIcon" src="assets/images/ppm/calendar.png"/></span>

    </div>
    <div class="col-md-2">
      &nbsp;
    </div>
  </div>

  <div class="col-md-12 noBottomMargin" *ngIf="isDayDisabled">
    <div class="col-md-4 noBottomMargin">&nbsp;</div>
    <div class="col-md-4 noBottomMargin alert alert-info customMargin centertext">Please choose month first</div>
    <div class="col-md-4 noBottomMargin">&nbsp;</div>
  </div>

    <div class="col-md-12 calendarDiv" *ngIf="showCustomRange">
    <div class="col-md-2">
      &nbsp;
    </div>
    <div class="col-md-3">
      <button type="button" class="btn btn-outline clearButn btnbalance" (click)="clearSearchData()">Clear</button>
    </div>
    <div class="col-md-2">
      &nbsp;
    </div>
    <div class="col-md-3">
      <button type="submit" class="btn btn-primary btnbalance" [disabled]="!customFundForm.valid || buttonDisabled">{{'document.search' | translate}}</button>
    </div>
    <div class="col-md-2">
      &nbsp;
    </div>
  </div>
   </form>
  <div class="col-md-12" *ngIf="invalidDateRange">
    <div class="alert alert-danger customMargin centertext">{{'transaction.invalidrange'|translate}}</div>
  </div>
  <div class="col-md-12" *ngIf="moreThan24Months">
    <div class="alert alert-danger customMargin centertext">{{'transaction.fund24monthvalidation'  | translate}}</div>
  </div>
  <div class="col-md-12  mainFundPerformDiv"  [ngSwitch]="progressIndicator" *ngIf="clearSearch">
				<span *ngSwitchCase="'loaded'">
            <div class="col-md-12 noBottomMargin">
                <div class="col-md-4">
                  &nbsp;
                </div>
                  <div class="col-md-4 centertext">
                    <button type="button"
                            class="btn btn-primary btnbalance" (click)="exportToPdf()">
                      <span class="glyphicon glyphicon-file-pdf"></span>&nbsp; Print Report
                    </button>
                  </div>
                <div class="col-md-4">
                  &nbsp;
                </div>
            </div>
				    <div id="charts" *ngFor="let chart of charts;let i = index;">
				        <div class="col-md-6">
				            <h4 tooltip-placement="left" class="centertext">{{chart.title}}</h4>
				            <canvas  id="{{ 'chart-data-' + i }}"  baseChart
                            [datasets]="chart.datasets"
                            [labels]="chart.labels"
                            [options]="barChartOptions"
                            [colors]="chartColors"
                            [legend]="barChartLegend"
                            [chartType]="barChartType"
                            (chartHover)="chartHovered($event)"
                            (chartClick)="chartClicked($event)"></canvas>
				        </div>
              <div class="legend" id="legenddiv-"></div>
				    </div>
				    <br><br><br>
				    <div class="col-md-1">
				    </div>
				    <div class="col-md-12" id="legend">
				    	<ul>
				    		<li style="list-style: none;"><label><strong>{{benchmarkLabel}}</strong></label></li>
				    	</ul>
				    	<ul>
							<li *ngFor="let chart of charts;let i = index;">
								<label class="typo-copy-small"><strong>{{chart.title}}</strong></label>
								<br>
								<img src="assets/images/ppm/benchmark.png" width="50" height="15" alt="" />
								<label class="typo-copy-small" style="font-style: italic;" >{{basedOn + ' ' + chart.benchmarkSource[0]}}</label>
							</li>
				    	</ul>
				    </div>
				</span>
				<span *ngSwitchCase="'timeout'">
					<div class="col-md-12 noBottomMargin alert alert-info centertext">{{'global.messages.info.timeout' | translate}}</div>
				</span>
       <span *ngSwitchCase="'loading'">
        <img class="loader" src="assets/images/loading.gif"/>
      </span>
       <span *ngSwitchCase="'nodata'">
        <div class="col-md-12 noBottomMargin alert alert-info centertext">{{'global.messages.info.nodata' | translate}}</div>
      </span>
      <span *ngSwitchDefault ><div class="col-md-12 noBottomMargin alert alert-info centertext">{{'global.messages.info.nodata' | translate}}</div></span>
  </div>
</div>

